/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Search_Words_StartInputs */

const en_us2_search_words_start = /** @type {(inputs: Search_Words_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`start begin train workout now session today`)
};

const pt_br2_search_words_start = /** @type {(inputs: Search_Words_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`comecar iniciar treinar treino agora sessao hoje`)
};

const es_419_search_words_start = /** @type {(inputs: Search_Words_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`empezar iniciar entrenar entrenamiento ahora sesion hoy`)
};

const pt_pt2_search_words_start = /** @type {(inputs: Search_Words_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`comecar iniciar treinar treino agora sessao hoje`)
};

const fr_fr2_search_words_start = /** @type {(inputs: Search_Words_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`commencer demarrer entrainer seance maintenant aujourd'hui`)
};

const de_de2_search_words_start = /** @type {(inputs: Search_Words_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`starten beginnen trainieren training jetzt einheit heute`)
};

const it_it2_search_words_start = /** @type {(inputs: Search_Words_StartInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`inizia comincia allenati allenamento ora sessione oggi`)
};

/**
* | output |
* | --- |
* | "start begin train workout now session today" |
*
* @param {Search_Words_StartInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const search_words_start = /** @type {((inputs?: Search_Words_StartInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Search_Words_StartInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_search_words_start(inputs)
	if (locale === "es-419") return es_419_search_words_start(inputs)
	if (locale === "pt-PT") return pt_pt2_search_words_start(inputs)
	if (locale === "fr-FR") return fr_fr2_search_words_start(inputs)
	if (locale === "de-DE") return de_de2_search_words_start(inputs)
	if (locale === "it-IT") return it_it2_search_words_start(inputs)
	return en_us2_search_words_start(inputs)
});
export { search_words_start as "search.words_start" }